module.exports = __webpack_public_path__ + "plaidManualLinkingConfirmationScreen.png";